import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  constructor(private http: HttpClient) { }
  // category, finalExamDuration, final, ongoing, markGroup
  addCourse(username: string, orgid: any, sfamilyid: any, subjectCode: string, subjectNameAr: string, subjectNameEn: string, classHours: number, practicalHours: number, totalHours: number, creditHours: number, passDegree: number, minClassHours: number, minPracticalHours: number, fullDegree: number, active: string, scatid: any, finalDurationHrs: any, examGradeFinal: any, examGradeOngoing: any, examGradeTotal: any, markGroupid: any) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmsubject/${username}`, { orgid, sfamilyid, subjectCode, subjectNameAr, subjectNameEn, classHours, practicalHours, totalHours, creditHours, passDegree, minClassHours, minPracticalHours, fullDegree, active, scatid, finalDurationHrs, examGradeFinal, examGradeOngoing, examGradeTotal, markGroupid });
  }
  updateCourse(username: string, id: any, orgid: any, sfamilyid: any, subjectCode: string, subjectNameAr: string, subjectNameEn: string, classHours: number, practicalHours: number, totalHours: number, creditHours: number, passDegree: number, minClassHours: number, minPracticalHours: number, fullDegree: number, active: string, scatid: any, finalDurationHrs: any, examGradeFinal: any, examGradeOngoing: any, examGradeTotal: any, markGroupid: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmsubject/${username}/${id}`, { id, orgid, sfamilyid, subjectCode, subjectNameAr, subjectNameEn, classHours, practicalHours, totalHours, creditHours, passDegree, minClassHours, minPracticalHours, fullDegree, active, scatid, finalDurationHrs, examGradeFinal, examGradeOngoing, examGradeTotal, markGroupid });
  }

  getAllCourses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubject`);
  }
  getCourseById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubject/${id}`);
  }

  addPreRequisetCourse(orgid: any, subjectid: any, prSubjectsid: any, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmsubjectpr`, { orgid, subjectid, prSubjectsid, active });
  }

  addCORequisetCourse(orgid: any, subjectid: any, crSubjectid: any, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcr`, { orgid, subjectid, crSubjectid, active });
  }

  deleteCORequisetCourse(subId: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcrbysubject/${subId}`);
  }

  deletePreRequisetCourse(subId: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/acmsubjectprbysubject/${subId}`);
  }
  getSubjectsByGroupSubjectId(orgId: any, yearId: any, semesterId: any, groupSubjectId: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgroupsubjects/${orgId}/${yearId}/${semesterId}/${groupSubjectId}`);
  }
}
